import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components/icons';
import { cn } from '../../../lib/utils';

export type MatchPercentBadgeProps = {
  matchPercent: number;
  className?: string;
};

export function MatchPercentBadge({
  matchPercent,
  className,
}: MatchPercentBadgeProps) {
  const { t } = useTranslation('matching');
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-primary-600 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary-foreground shadow-sm',
        className,
      )}
    >
      <Icon name='paw-print-filled' className='size-3.5' />
      {t('results.matchBadge', { percent: matchPercent })}
    </span>
  );
}
